import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "min-h-screen bg-[#f8f6f6] text-skribi-teal antialiased" }
const _hoisted_2 = { class: "sticky top-0 z-50 w-full border-b border-skribi-blue/40 bg-skribi-teal text-white backdrop-blur-md" }
const _hoisted_3 = { class: "mx-auto flex max-w-7xl items-center justify-between px-6 py-4" }
const _hoisted_4 = { class: "hidden items-center gap-8 md:flex" }
const _hoisted_5 = ["href", "onClick"]
const _hoisted_6 = {
  class: "relative overflow-hidden py-12 lg:py-16",
  id: "hero"
}
const _hoisted_7 = { class: "mx-auto max-w-7xl px-6" }
const _hoisted_8 = { class: "grid items-center gap-12 lg:grid-cols-2" }
const _hoisted_9 = { class: "relative" }
const _hoisted_10 = { class: "aspect-square rounded-3xl bg-gradient-to-br from-skribi-blue/40 to-skribi-teal/10 p-4 shadow-2xl" }
const _hoisted_11 = { class: "hero-parallax-frame h-full w-full rounded-2xl shadow-inner" }
const _hoisted_12 = {
  class: "bg-white py-24",
  id: "solutions"
}
const _hoisted_13 = { class: "mx-auto max-w-7xl px-6" }
const _hoisted_14 = { class: "grid gap-12 md:grid-cols-2" }
const _hoisted_15 = { class: "flex h-14 w-14 items-center justify-center rounded-xl bg-skribi-blue/30 text-skribi-teal" }
const _hoisted_16 = { class: "material-symbols-outlined text-3xl" }
const _hoisted_17 = { class: "text-xl font-bold" }
const _hoisted_18 = { class: "text-skribi-teal/70" }
const _hoisted_19 = {
  class: "bg-white py-24",
  id: "analysis"
}
const _hoisted_20 = { class: "mx-auto max-w-7xl px-6" }
const _hoisted_21 = { class: "mt-12 grid gap-6 md:grid-cols-3" }
const _hoisted_22 = { class: "mb-4 flex h-12 w-12 items-center justify-center rounded-xl bg-skribi-blue/20 text-skribi-teal" }
const _hoisted_23 = { class: "material-symbols-outlined text-2xl" }
const _hoisted_24 = { class: "text-xl font-bold" }
const _hoisted_25 = { class: "mt-3 text-skribi-teal/70" }
const _hoisted_26 = {
  class: "bg-white py-24",
  id: "impact"
}
const _hoisted_27 = { class: "mx-auto max-w-7xl px-6" }
const _hoisted_28 = { class: "overflow-x-auto rounded-2xl border border-skribi-blue/40 bg-white shadow-sm" }
const _hoisted_29 = { class: "min-w-full divide-y divide-skribi-blue/40" }
const _hoisted_30 = { class: "divide-y divide-skribi-blue/30 text-sm text-skribi-teal/80" }
const _hoisted_31 = { class: "px-6 py-4" }
const _hoisted_32 = { class: "px-6 py-4 font-semibold text-skribi-teal" }
const _hoisted_33 = {
  class: "py-24",
  id: "use-cases"
}
const _hoisted_34 = { class: "mx-auto max-w-7xl px-6" }
const _hoisted_35 = { class: "grid gap-8 lg:grid-cols-2" }
const _hoisted_36 = { class: "grid sm:grid-cols-5" }
const _hoisted_37 = ["aria-label"]
const _hoisted_38 = { class: "col-span-3 flex flex-col justify-center p-8" }
const _hoisted_39 = { class: "mb-3 text-2xl font-bold leading-snug" }
const _hoisted_40 = { class: "mb-6 text-skribi-teal/70" }
const _hoisted_41 = { class: "mb-8 space-y-2 text-sm text-skribi-teal/80" }
const _hoisted_42 = ["onClick"]
const _hoisted_43 = {
  class: "bg-skribi-teal py-20 text-white",
  id: "contact"
}
const _hoisted_44 = { class: "mx-auto max-w-7xl px-6" }
const _hoisted_45 = { class: "grid gap-16 lg:grid-cols-2" }
const _hoisted_46 = { class: "rounded-2xl border border-white/10 bg-white/5 p-8 backdrop-blur-sm" }

import { nextTick, onMounted, onUnmounted, ref } from 'vue'
import RetoursPatientsView from './components/RetoursPatientsView.vue'

interface NavLink {
  label: string
  href: string
  view: 'home' | 'retours'
}

interface ProblemPoint {
  icon: string
  title: string
  description: string
}

interface SolutionBenefit {
  icon: string
  title: string
  description: string
}

interface BulletPoint {
  icon: string
  text: string
  iconClass: string
}

interface UseCase {
  tag: string
  tagClass: string
  title: string
  description: string
  bullets: BulletPoint[]
  ctaClass: string
  ctaTarget: 'retours' | 'contact'
  featured?: boolean
  image: string
  imageAlt: string
}

type AppView = 'home' | 'retours'

const heroImage =
  'https://lh3.googleusercontent.com/aida-public/AB6AXuD0qantXLaaqelwOZjzNThdFqSyPxXsj8dSxRmapVxLrfBFeLcu7zzXOAqg5BuJBT-ZRYF4s4bwHb_x6RbPvXtzBhkJVm4rJfytd9fGmZGHR6uQA_-5yngKgy52UMRYhi04mLu_RjkRfk_iAYb0jQNCsKjKz7FleDwkEURq-5MblyVAnn9ewyTlrstD2285gqcg54P95kC97K1vd38R7N7l4m-YO13sl00DrQ06vBIpPUPZDsJLDFKgl-UEmuuEoD86jMW-gIBVLCY'


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const heroParallaxEl = ref<HTMLElement | null>(null)
const contactFormEl = ref<HTMLFormElement | null>(null)
let heroParallaxFrame = 0
let contactTrackingFallbackTimer = 0

const updateHeroParallax = () => {
  if (!heroParallaxEl.value) {
    return
  }

  const rect = heroParallaxEl.value.getBoundingClientRect()
  const viewportHeight = window.innerHeight
  const progress = (viewportHeight - rect.top) / (viewportHeight + rect.height)
  const clamped = Math.max(0, Math.min(progress, 1))
  const maxOffset = 70
  const offset = (clamped - 0.5) * -2 * maxOffset

  heroParallaxEl.value.style.setProperty('--hero-parallax-offset', `${offset}px`)
}

const onHeroScroll = () => {
  if (heroParallaxFrame) {
    return
  }

  heroParallaxFrame = window.requestAnimationFrame(() => {
    updateHeroParallax()
    heroParallaxFrame = 0
  })
}

const submitContactForm = () => {
  if (!contactFormEl.value) {
    return
  }

  contactFormEl.value.submit()
}

const trackContactFormSubmit = () => {
  const gtagFn = (window as Window & { gtag?: any }).gtag
  if (typeof gtagFn !== 'function') {
    return false
  }

  let hasSubmitted = false
  const onTracked = () => {
    if (hasSubmitted) {
      return
    }

    hasSubmitted = true
    if (contactTrackingFallbackTimer) {
      window.clearTimeout(contactTrackingFallbackTimer)
      contactTrackingFallbackTimer = 0
    }
    submitContactForm()
  }

  contactTrackingFallbackTimer = window.setTimeout(onTracked, 1000)
  gtagFn('event', 'contact_form_submit', {
    event_category: 'lead',
    event_label: 'landing_page_contact_form',
    transport_type: 'beacon',
    event_callback: onTracked,
  })

  return true
}

const onContactFormSubmit = (event: Event) => {
  event.preventDefault()

  if (!trackContactFormSubmit()) {
    submitContactForm()
  }
}

onMounted(() => {
  updateViewFromHash()
  updateHeroParallax()
  window.addEventListener('scroll', onHeroScroll, { passive: true })
  window.addEventListener('resize', onHeroScroll)
  window.addEventListener('hashchange', updateViewFromHash)
})

onUnmounted(() => {
  window.removeEventListener('scroll', onHeroScroll)
  window.removeEventListener('resize', onHeroScroll)
  window.removeEventListener('hashchange', updateViewFromHash)
  if (heroParallaxFrame) {
    window.cancelAnimationFrame(heroParallaxFrame)
  }
  if (contactTrackingFallbackTimer) {
    window.clearTimeout(contactTrackingFallbackTimer)
  }
})

const currentView = ref<AppView>('home')

const homeNavLinks: NavLink[] = [
  { label: 'Solutions', href: '#solutions', view: 'home' },
  { label: 'Analyse', href: '#analysis', view: 'home' },
  { label: "Cas d'usage", href: '#use-cases', view: 'home' },
  { label: 'Retours patients', href: '#retours-patients', view: 'retours' },
  { label: 'À propos', href: '#contact', view: 'home' },
]

const retoursNavLinks: NavLink[] = [
  { label: 'Accueil', href: '#hero', view: 'home' },
  { label: 'Contact', href: '#contact', view: 'home' },
]

const activeNavLinks = ref<NavLink[]>(homeNavLinks)

const syncNavLinks = () => {
  activeNavLinks.value = currentView.value === 'retours' ? retoursNavLinks : homeNavLinks
}

const updateViewFromHash = () => {
  currentView.value = window.location.hash === '#retours-patients' ? 'retours' : 'home'
  syncNavLinks()
}

const openRetoursView = async () => {
  currentView.value = 'retours'
  syncNavLinks()
  window.history.replaceState(null, '', '#retours-patients')
  await nextTick()
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

const openHomeView = async (target = '#hero') => {
  currentView.value = 'home'
  syncNavLinks()
  await nextTick()
  const targetElement = document.querySelector(target)
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: 'smooth' })
    window.history.replaceState(null, '', target)
    return
  }

  window.history.replaceState(null, '', '/')
  window.scrollTo({ top: 0, behavior: 'smooth' })
}

const onNavLinkClick = async (event: Event, link: NavLink) => {
  event.preventDefault()
  if (link.view === 'retours') {
    await openRetoursView()
    return
  }

  await openHomeView(link.href)
}

const problemPoints: ProblemPoint[] = [
  {
    icon: 'list_alt',
    title: 'Des questionnaires trop nombreux et trop rigides',
    description:
      "Oxford Knee Score, EQ-5D, KOOS selon la specialite - choisir, envoyer, relancer : une charge que personne n'a le temps de gerer.",
  },
  {
    icon: 'percent',
    title: 'Des taux de reponse decevants',
    description:
      "20 a 35 % avec les formulaires papier ou email. La majorite du vecu patient ne vous parvient jamais.",
  },
  {
    icon: 'schedule',
    title: "Des donnees qui n'arrivent pas au bon moment",
    description:
      "e-Satis mesure la satisfaction a chaud, pas le resultat fonctionnel a J+30 ou J+90. Vous pilotez a l'aveugle.",
  },
  {
    icon: 'gavel',
    title: "Une pression reglementaire qui s'accelere",
    description:
      "La certification HAS 2025 (critere 1.4-03) et l'IFAQ exigent de mesurer ce que le patient ressent - pas seulement ce que vous avez produit.",
  },
]

const solutionBenefits: SolutionBenefit[] = [
  {
    icon: 'tune',
    title: 'Le bon protocole, automatiquement',
    description:
      "L'IA selectionne les indicateurs adaptes a la specialite et a l'etape du parcours. Vous configurez une fois.",
  },
  {
    icon: 'data_check',
    title: 'Donnees structurees le lendemain',
    description:
      'Chaque conversation produit un score et un verbatim structure dans votre dashboard. Zero ressaisie.',
  },
  {
    icon: 'task_alt',
    title: 'Compatible HAS et IFAQ nativement',
    description:
      'Vos exports sont prets pour vos reportings reglementaires en 1 clic.',
  },
]

const useCases: UseCase[] = [
  {
    tag: 'Resultats patients',
    tagClass: 'bg-skribi-orange/10 text-skribi-orange',
    title: 'Suivi des résultats de santé',
    description:
      "Mesurez l'efficacité clinique à travers le vécu du patient en post-opératoire ou pour les maladies chroniques.",
    bullets: [
      { icon: 'check_circle', text: 'Récupération fonctionnelle', iconClass: 'text-skribi-orange' },
      { icon: 'check_circle', text: 'Évolution de la douleur', iconClass: 'text-skribi-orange' },
      { icon: 'check_circle', text: 'Impact sur la vie quotidienne', iconClass: 'text-skribi-orange' },
    ],
    ctaClass: 'text-skribi-orange',
    ctaTarget: 'retours',
    image: '/OutilMonitoring.png',
    imageAlt: 'Moniteur de patient en post-opératoire',
  },
  {
    tag: 'Experience patient',
    tagClass: 'bg-skribi-teal/10 text-skribi-teal',
    title: 'Expérience patient',
    description:
      "Cartographiez le parcours de soins et identifiez les signaux faibles pour améliorer la qualité de l'accueil et du séjour.",
    bullets: [
      { icon: 'sentiment_satisfied', text: 'Satisfaction globale', iconClass: 'text-skribi-teal' },
      { icon: 'hub', text: 'Fluidité du parcours', iconClass: 'text-skribi-teal' },
      { icon: 'record_voice_over', text: 'Relation soignant-soigné', iconClass: 'text-skribi-teal' },
    ],
    ctaClass: 'text-skribi-teal',
    ctaTarget: 'retours',
    image: '/PatientEtSoignant.png',
    imageAlt: 'Patient échangeant avec un médecin',
  },
  {
    tag: 'Expérience Aidants',
    tagClass: 'bg-indigo-100 text-indigo-700',
    title: 'Expérience Famille & Aidants',
    description:
      "Captez le vécu des proches aidants par conversation naturelle — le premier référentiel CROM en France pour mesurer ce que les questionnaires ne capturent jamais.",
    bullets: [
      { icon: 'favorite', text: 'Soins palliatifs, urgences, SSR rééducation', iconClass: 'text-indigo-500' },
      { icon: 'bar_chart', text: '15 indicateurs CROM standardisés', iconClass: 'text-indigo-500' },
      { icon: 'lock', text: 'Verbatims anonymisés pour l\'équipe qualité', iconClass: 'text-indigo-500' },
    ],
    ctaClass: 'text-indigo-600',
    ctaTarget: 'contact',
    featured: true,
    image: '/PatientEtAidant.png',
    imageAlt: 'Proche accompagnant un patient hospitalisé',
  },
]

const beforeAfterRows = [
  {
    before: 'Selection manuelle des questionnaires',
    after: "Selection automatique par l'IA",
  },
  {
    before: 'Envoi et relance a la main',
    after: 'Automatise par SMS',
  },
  {
    before: 'Taux de reponse faibles',
    after: 'Taux de reponse nettement ameliores',
  },
  {
    before: 'Donnees en silo, non structurees',
    after: 'Dashboard qualite en temps reel',
  },
  {
    before: 'Mois de travail pour les reportings',
    after: 'Export HAS/IFAQ pret en 1 clic',
  },
]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", {
          href: "#hero",
          class: "flex items-center gap-3",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (openHomeView('#hero')), ["prevent"]))
        }, [...(_cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "flex h-10 w-10 items-center justify-center rounded-lg text-white" }, [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Skribi Care",
              class: "h-10 w-10"
            })
          ], -1),
          _createElementVNode("span", { class: "text-xl font-extrabold tracking-tight text-white" }, "Skribi Care", -1)
        ]))]),
        _createElementVNode("nav", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeNavLinks.value, (link) => {
            return (_openBlock(), _createElementBlock("a", {
              key: link.label,
              href: link.href,
              class: "text-sm font-semibold transition-colors hover:text-skribi-orange",
              onClick: ($event: any) => (onNavLinkClick($event, link))
            }, _toDisplayString(link.label), 9, _hoisted_5))
          }), 128))
        ]),
        _createElementVNode("a", {
          href: "#contact",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (openHomeView('#contact')), ["prevent"])),
          class: "rounded-lg bg-skribi-orange px-5 py-2.5 text-sm font-bold text-white shadow-lg transition-all hover:bg-skribi-orange/90 hover:scale-[1.02]"
        }, " Contacter l'équipe ")
      ])
    ]),
    (currentView.value === 'retours')
      ? (_openBlock(), _createBlock(RetoursPatientsView, {
          key: 0,
          onGoHome: openHomeView
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("section", _hoisted_6, [
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "absolute inset-0 -z-10 bg-[radial-gradient(45%_45%_at_50%_50%,#B6CFD4_0%,transparent_100%)] opacity-30" }, null, -1)),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _cache[4] || (_cache[4] = _createStaticVNode("<div class=\"flex flex-col gap-8\"><div class=\"inline-flex items-center gap-2 rounded-full bg-skribi-blue/30 px-4 py-1.5 text-sm font-bold text-skribi-teal\"><span class=\"material-symbols-outlined text-sm\">auto_awesome</span> IA Conversationnelle </div><h1 class=\"text-4xl font-black leading-tight tracking-tight sm:text-5xl lg:text-6xl\"> Le récit patient, enfin exploitable pour vos équipes qualité </h1><p class=\"max-w-xl text-lg leading-relaxed text-skribi-teal/80\"> Skribi Care collecte le récit de vos patients par conversation naturelle, et le transforme en données exploitables pour vos équipes qualité. </p><div class=\"flex flex-col gap-4 sm:flex-row\"><a href=\"#contact\" class=\"inline-flex items-center justify-center rounded-lg bg-skribi-orange px-8 py-4 text-base font-bold text-white shadow-xl transition-all hover:bg-skribi-orange/90\"> Demander une démo </a></div></div>", 1)),
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("div", {
                        ref_key: "heroParallaxEl",
                        ref: heroParallaxEl,
                        class: "hero-parallax-image",
                        style: _normalizeStyle({ backgroundImage: `url(${heroImage})` }),
                        "aria-label": "Professionnel de santé utilisant une tablette"
                      }, null, 4)
                    ])
                  ]),
                  _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"absolute -bottom-6 -left-6 flex items-center gap-4 rounded-2xl border border-skribi-blue/40 bg-white p-4 shadow-xl\"><div class=\"flex h-12 w-12 items-center justify-center rounded-full bg-green-100 text-green-600\"><span class=\"material-symbols-outlined\">verified_user</span></div><div><p class=\"text-xs font-bold text-skribi-teal/60\">Conformité</p><p class=\"text-sm font-bold text-skribi-teal\">100% HDS &amp; RGPD</p></div></div>", 1))
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "mb-16 text-center" }, [
                _createElementVNode("h2", { class: "text-3xl font-bold tracking-tight sm:text-4xl" }, "Ce que vos équipes vivent aujourd'hui"),
                _createElementVNode("div", { class: "mt-4 flex justify-center" }, [
                  _createElementVNode("div", { class: "h-1.5 w-24 rounded-full bg-skribi-orange" })
                ])
              ], -1)),
              _createElementVNode("div", _hoisted_14, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(problemPoints, (item) => {
                  return _createElementVNode("div", {
                    key: item.title,
                    class: "flex flex-col items-start gap-4 rounded-2xl border border-skribi-blue/40 p-6"
                  }, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", _hoisted_16, _toDisplayString(item.icon), 1)
                    ]),
                    _createElementVNode("h3", _hoisted_17, _toDisplayString(item.title), 1),
                    _createElementVNode("p", _hoisted_18, _toDisplayString(item.description), 1)
                  ])
                }), 64))
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"grid items-center gap-14 lg:grid-cols-2\"><div class=\"flex flex-col gap-8\"><span class=\"inline-flex w-fit rounded-full bg-skribi-orange/10 px-4 py-1.5 text-xs font-bold uppercase tracking-widest text-skribi-orange\"> La solution Skribi Care </span><div class=\"space-y-4\"><h2 class=\"text-3xl font-bold tracking-tight sm:text-4xl\">Une conversation remplace tous vos questionnaires</h2><p class=\"text-lg leading-relaxed text-skribi-teal/70\"> Une discussion naturelle suffit pour recueillir le vécu patient et produire des indicateurs utiles des le lendemain, sans alourdir la charge de vos equipes. </p></div></div><div class=\"rounded-3xl bg-white p-6 shadow-2xl\"><div class=\"rounded-2xl border border-skribi-blue/40 bg-[#fdfdfd] p-6\"><div class=\"flex items-center justify-between text-xs text-skribi-teal/50\"><div class=\"flex items-center gap-2\"><span class=\"h-2 w-2 rounded-full bg-skribi-orange\"></span><span>sms.skribi.care/conversation/orthopedie-j30</span></div><div class=\"flex gap-1\"><span class=\"h-2 w-2 rounded-full bg-skribi-orange/40\"></span><span class=\"h-2 w-2 rounded-full bg-skribi-blue\"></span><span class=\"h-2 w-2 rounded-full bg-skribi-teal/30\"></span></div></div><div class=\"mt-6 space-y-3 text-sm\"><div class=\"ml-auto max-w-[85%] rounded-2xl bg-skribi-blue/20 px-4 py-3 text-skribi-teal\"> Bonjour Mme Martin, comment evolue votre genou depuis l&#39;operation il y a 30 jours ? </div><div class=\"mr-auto max-w-[85%] rounded-2xl bg-skribi-orange/15 px-4 py-3 text-skribi-teal\"> Je remonte bien les escaliers, douleur legere le soir seulement. </div><div class=\"ml-auto max-w-[85%] rounded-2xl bg-skribi-blue/20 px-4 py-3 text-skribi-teal\"> Sur une echelle de 0 a 10, quelle est votre douleur moyenne aujourd&#39;hui ? </div><div class=\"mr-auto max-w-[85%] rounded-2xl bg-skribi-orange/15 px-4 py-3 text-skribi-teal\"> 3/10. Je marche 20 minutes sans m&#39;arreter. </div><div class=\"rounded-2xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-xs font-semibold text-emerald-700\"> Score fonctionnel calcule automatiquement + verbatim structure disponible dans le dashboard. </div></div></div></div></div>", 1)),
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(solutionBenefits, (benefit) => {
                  return _createElementVNode("article", {
                    key: benefit.title,
                    class: "rounded-2xl border border-skribi-blue/40 bg-white p-6 shadow-sm"
                  }, [
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(benefit.icon), 1)
                    ]),
                    _createElementVNode("h3", _hoisted_24, _toDisplayString(benefit.title), 1),
                    _createElementVNode("p", _hoisted_25, _toDisplayString(benefit.description), 1)
                  ])
                }), 64))
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_26, [
            _createElementVNode("div", _hoisted_27, [
              _cache[9] || (_cache[9] = _createElementVNode("div", { class: "mb-10 text-center" }, [
                _createElementVNode("h2", { class: "text-3xl font-bold tracking-tight sm:text-4xl" }, "Ce que ca change pour votre equipe qualite")
              ], -1)),
              _createElementVNode("div", _hoisted_28, [
                _createElementVNode("table", _hoisted_29, [
                  _cache[8] || (_cache[8] = _createElementVNode("thead", { class: "bg-skribi-blue/15" }, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-bold text-skribi-teal" }, "Avant"),
                      _createElementVNode("th", { class: "px-6 py-4 text-left text-sm font-bold text-skribi-teal" }, "Apres Skribi Care")
                    ])
                  ], -1)),
                  _createElementVNode("tbody", _hoisted_30, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(beforeAfterRows, (row) => {
                      return _createElementVNode("tr", {
                        key: row.before
                      }, [
                        _createElementVNode("td", _hoisted_31, _toDisplayString(row.before), 1),
                        _createElementVNode("td", _hoisted_32, _toDisplayString(row.after), 1)
                      ])
                    }), 64))
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, [
              _cache[11] || (_cache[11] = _createElementVNode("h2", { class: "mb-12 text-3xl font-bold" }, "Cas d'usage", -1)),
              _createElementVNode("div", _hoisted_35, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(useCases, (useCase) => {
                  return _createElementVNode("article", {
                    key: useCase.title,
                    class: _normalizeClass(["group relative overflow-hidden rounded-3xl bg-white shadow-xl transition-all hover:shadow-2xl", { 'lg:col-span-2': useCase.featured }])
                  }, [
                    _createElementVNode("div", _hoisted_36, [
                      _createElementVNode("div", {
                        class: "col-span-2 h-64 bg-cover bg-center sm:h-auto",
                        style: _normalizeStyle({ backgroundImage: `url(${useCase.image})` }),
                        "aria-label": useCase.imageAlt
                      }, null, 12, _hoisted_37),
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("div", {
                          class: _normalizeClass(["mb-4 inline-flex w-fit rounded-full px-3 py-1 text-xs font-bold uppercase tracking-wider", useCase.tagClass])
                        }, _toDisplayString(useCase.tag), 3),
                        _createElementVNode("h3", _hoisted_39, _toDisplayString(useCase.title), 1),
                        _createElementVNode("p", _hoisted_40, _toDisplayString(useCase.description), 1),
                        _createElementVNode("ul", _hoisted_41, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(useCase.bullets, (bullet) => {
                            return (_openBlock(), _createElementBlock("li", {
                              key: bullet.text,
                              class: "flex items-center gap-2"
                            }, [
                              _createElementVNode("span", {
                                class: _normalizeClass(["material-symbols-outlined text-lg", bullet.iconClass])
                              }, _toDisplayString(bullet.icon), 3),
                              _createTextVNode(" " + _toDisplayString(bullet.text), 1)
                            ]))
                          }), 128))
                        ]),
                        _createElementVNode("a", {
                          href: "#",
                          class: _normalizeClass(["flex items-center gap-2 font-bold transition-all group-hover:gap-3", useCase.ctaClass]),
                          onClick: _withModifiers(($event: any) => (useCase.ctaTarget === 'retours' ? openRetoursView() : openHomeView('#contact')), ["prevent"])
                        }, [...(_cache[10] || (_cache[10] = [
                          _createTextVNode(" En savoir plus ", -1),
                          _createElementVNode("span", { class: "material-symbols-outlined" }, "arrow_forward", -1)
                        ]))], 10, _hoisted_42)
                      ])
                    ])
                  ], 2)
                }), 64))
              ])
            ])
          ]),
          _cache[15] || (_cache[15] = _createStaticVNode("<section class=\"border-y border-skribi-blue/40 bg-skribi-blue/10 py-16\" id=\"security\"><div class=\"mx-auto flex max-w-7xl flex-col items-center justify-between gap-12 px-6 md:flex-row\"><div class=\"max-w-xl\"><h2 class=\"mb-4 text-3xl font-bold\">Sécurité HDS</h2><p class=\"text-skribi-teal/70\"> Vos données de santé sont précieuses. Skribi Care garantit une confidentialité totale et une conformité stricte aux réglementations européennes et françaises. </p></div><div class=\"flex items-center gap-10\"><div class=\"flex flex-col items-center gap-2\"><div class=\"flex h-20 w-32 items-center justify-center rounded-xl bg-white shadow-sm\"><span class=\"text-xl font-bold text-blue-600\">Azure</span></div><span class=\"text-xs font-bold uppercase tracking-widest text-skribi-teal/50\">Hébergé sur Azure HDS</span></div><div class=\"flex flex-col items-center gap-2\"><div class=\"flex h-20 w-32 items-center justify-center rounded-xl bg-white shadow-sm\"><span class=\"text-xl font-bold text-gray-800\">RGPD</span></div><span class=\"text-xs font-bold uppercase tracking-widest text-skribi-teal/50\">100% Compliant</span></div></div></div></section>", 1)),
          _createElementVNode("footer", _hoisted_43, [
            _createElementVNode("div", _hoisted_44, [
              _createElementVNode("div", _hoisted_45, [
                _cache[13] || (_cache[13] = _createStaticVNode("<div><h2 class=\"mt-10 mb-6 text-4xl font-bold leading-tight\">Pret a ecouter vos patients autrement ?</h2><p class=\"mb-6 text-lg text-white/70\"> Nous proposons un pilote de 3 mois sur une specialite de votre choix. Resultats mesurables des le premier mois. </p><p class=\"mb-6 text-sm text-white/60\"> Deploiement en 4 semaines · Sans integration SI complexe · Accompagnement inclus </p><div class=\"space-y-4\"><div class=\"flex items-center gap-4\"><span class=\"material-symbols-outlined text-skribi-orange\">mail</span><span><a href=\"mailto:contact@skribi.care\">contact@skribi.care</a></span></div><div class=\"flex items-center gap-4\"><span class=\"material-symbols-outlined text-skribi-orange\">location_on</span><span>Sophia Antipolis &amp; Station F, France</span></div></div></div>", 1)),
                _createElementVNode("div", _hoisted_46, [
                  _createElementVNode("form", {
                    ref_key: "contactFormEl",
                    ref: contactFormEl,
                    class: "grid gap-4",
                    action: "https://formsubmit.co/contact@skribi.care",
                    method: "POST",
                    onSubmit: onContactFormSubmit
                  }, [...(_cache[12] || (_cache[12] = [
                    _createStaticVNode("<input type=\"hidden\" name=\"_subject\" value=\"Nouveau contact Skribi Care\"><input type=\"hidden\" name=\"_captcha\" value=\"false\"><input type=\"hidden\" name=\"_template\" value=\"table\"><input type=\"hidden\" name=\"_next\" value=\"https://skribi.care/merci.html\"><div class=\"grid gap-4 sm:grid-cols-2\"><div class=\"flex flex-col gap-1.5\"><label class=\"text-xs font-bold uppercase text-white/50\">Nom</label><input class=\"rounded-lg border-0 bg-white/10 p-3 text-white placeholder:text-white/40 focus:ring-2 focus:ring-skribi-orange\" placeholder=\"Jean Dupont\" type=\"text\" name=\"name\" required></div><div class=\"flex flex-col gap-1.5\"><label class=\"text-xs font-bold uppercase text-white/50\">Établissement</label><input class=\"rounded-lg border-0 bg-white/10 p-3 text-white placeholder:text-white/40 focus:ring-2 focus:ring-skribi-orange\" placeholder=\"Hôpital Central\" type=\"text\" name=\"organization\"></div></div><div class=\"flex flex-col gap-1.5\"><label class=\"text-xs font-bold uppercase text-white/50\">Email professionnel</label><input class=\"rounded-lg border-0 bg-white/10 p-3 text-white placeholder:text-white/40 focus:ring-2 focus:ring-skribi-orange\" placeholder=\"jean.dupont@hopital.fr\" type=\"email\" name=\"email\" required></div><div class=\"flex flex-col gap-1.5\"><label class=\"text-xs font-bold uppercase text-white/50\">Message</label><textarea class=\"rounded-lg border-0 bg-white/10 p-3 text-white placeholder:text-white/40 focus:ring-2 focus:ring-skribi-orange\" placeholder=\"Parlez-nous de votre projet...\" rows=\"3\" name=\"message\" required></textarea></div><button class=\"mt-4 rounded-lg bg-skribi-orange py-4 text-base font-bold text-white transition-all hover:bg-skribi-orange/90\"> Échanger sur un projet pilote </button>", 8)
                  ]))], 544)
                ])
              ]),
              _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"mt-20 flex flex-col items-center justify-between gap-4 border-t border-white/10 pt-8 text-sm text-white/50 md:flex-row\"><div class=\"flex items-center gap-2\"><span class=\"material-symbols-outlined text-sm\">clinical_notes</span><span class=\"font-bold text-white\">Skribi Care</span><span>© 2026 - Tous droits réservés.</span></div><div class=\"flex gap-8\"><a class=\"hover:text-white\" href=\"/mentions-legales.html\">Mentions légales</a></div></div>", 1))
            ])
          ])
        ], 64))
  ]))
}
}

})